<template>
    <div class="list">
      
      <div class="d-flex flex-wrap" v-if="!status.loading && items.length > 0">
        <div :class="`item ${colClass[componentClass] ? colClass[componentClass] : colClass.default}`" v-for="(item, index) in filteredItems" :key="index">
          <template v-if="componentName === 'Blog'">
            <BlogItem :item="item" :configTexts="configTexts" :locale="locale"/>
          </template>

          <template v-else-if="componentName === 'Promotions'">
            <PromotionItem :item="item" :configTexts="configTexts" :locale="locale" :contentVersionID="contentVersionID"/>
          </template>

          <template v-else-if="componentName === 'Catalog'">
            <CatalogItem class="bg-white d-flex justify-content-between flex-column h-100" :item="item" :configTexts="configTexts" :locale="locale" :contentVersionID="contentVersionID"/>
          </template>

          <template v-else-if="componentName === 'Services'">
            <ServiceItem :item="item" :configTexts="configTexts" :locale="locale" :contentVersionID="contentVersionID"/>
          </template>

          <template v-else>
            <DefaultItem :item="item" :configTexts="configTexts" :locale="locale"/>
          </template>
        </div>
      </div>

      <div class="w-100" v-else-if="status.loading">
        <Skeleton :component="componentName.toLowerCase()" />
      </div>

      <div class="d-flex place-content-center" v-else>
        <div class="text-center-2">
          <img class="img-not-found" src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/icon-notfound"/>
          <p class="fw-bold mt-2">{{$locale === 'es' ? 'No se encontraron resultados para tu búsqueda' : 'No results were found for your search'}}</p>
        </div>
      </div>
    </div>
</template>
<script>
import Pagination from './Pagination.vue';
import BlogItem from './list-components/BlogItem.vue';
import DefaultItem from './list-components/DefaultItem.vue';
import PromotionItem from './list-components/PromotionItem.vue';
import CatalogItem from './list-components/CatalogItem.vue';
import ServiceItem from './list-components/ServiceItem.vue';
import Skeleton from './Skeleton.vue';

export default {
  props: { 
    config: Object,
    locale: String,
    configTexts: Object,
    page: Number,
    pageSize: Number,
    metadata: Object,
    status: Object,
    total: Number,
    pages: Number,
  },
  components: { Pagination, BlogItem, DefaultItem, PromotionItem, CatalogItem, ServiceItem, Skeleton },
  data: () => ({
    items: [],
    colClass: {
      default: 'col-lg-3 col-12 col-sm-6 col-md-4 col-xl-3',
      promotions: 'col-lg-4 col-12 col-sm-6',
      services: 'col-lg-6 col-sm-12 col-12'
    }
  }),
  computed: {
    componentName() {
      return this.config && this.config.component ? this.config.component : 'Default';
    },
    componentClass() {
      return this.componentName.toLowerCase();
    },
    contentVersionID() {
      return this.metadata?.response_version_id
    },
    filteredItems() {
      return this.componentName !== 'Promotions' ? this.items : this.items.filter(x => x.relationships.story.store[0])
    }
  },
  methods: {
    getData() {
      if (!this.config.api && this.status.loading) return;

      this.status.loading = true;
      let queryString = window.location.search;

      if (queryString.includes('?')) {
        queryString = queryString + `&page=${this.page + 1}&pageSize=${this.pageSize}&locale=${this.locale}`
      } else {
        queryString = queryString + `?page=${this.page + 1}&pageSize=${this.pageSize}&locale=${this.locale}`
      }

      this.$axios.get(this.config.api + queryString).then(response => {
        this.items = response.data.data;
        if(this.page === 0) this.$emit('updateMetadata', response.data.meta)
      }).finally(() => {
        this.status.loading = false;
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.place-content-center {
  place-content: center;
}

.text-center-2 {
  text-align: center;
  text-align: -webkit-center;
}

.img-not-found {
  width: 200px;
  height: auto;
}
</style>
